export const ADDRESS_INFO_MAIN_VIEW_MODE = {
    view: "view",
    edit: "edit",
} as const;